import React, { FC } from 'react';
import styles from './FindingOverlayCard.module.scss';
import FindingOverlayCardProperties from './FindingOverlayCardProperty';

type AnnotationGridRowDataSource = {
  finding: any | undefined;
  showFindingOverlayOnLeft: boolean;
};

const leftPosition = {
  padding: '10px',
  left: 15,
  top: 120
};

const rightPosition = {
  padding: '10px',
  right: 80,
  top: 15
};

const FindingOverlayCard: FC<AnnotationGridRowDataSource> = ({ finding, showFindingOverlayOnLeft }) => {
  return (
    <ul style={showFindingOverlayOnLeft ? leftPosition : rightPosition} className={styles.container}>
      <li>FINDING INFO</li>
      <li>
        <table>
          <FindingOverlayCardProperties finding={finding} />
        </table>
      </li>
    </ul>
  );
};

export default FindingOverlayCard;
